import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import { Observable, ObservableInput } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Injectable } from '@angular/core';
import { ScreeningService } from '../screening-module/services/screening.service';

@Injectable()
export class AddHttpHeaderInterceptor implements HttpInterceptor {
  constructor(private auth : AuthService, public screening: ScreeningService){
    // console.log('calling interceptor constructor');
  }
  // constructor(){
  //   console.log('calling interceptor constructor')
  // }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Get the auth header from the service.
    const authHeader = "Bearer " + localStorage.getItem("STP-JWT");
    const clonedReq = req.clone({headers: req.headers.set('Authorization', authHeader)});

    return next.handle(clonedReq).pipe( tap(() => {},
    (err: any) => {
    if (err instanceof HttpErrorResponse) {
      if (err.status == 401 || err.status == 403)  {
        // this.screening.WriteLogToRIQ({
        //   loggerMessage: "SCRN-FORCE-LOGOUT",
        //   clonedReq,
        //   usr: this.auth.loggedInUser.userName
        // })
       this.auth.logout();
      }else return;
    }
  }));

  }
}